import { matchPath } from "@remix-run/react";
export const findRoute = (path, routes) => routes.find(route => {
  const match = matchPath({
    ...route,
    end: true
  }, path);
  return match !== undefined && match !== null;
});